import type { IconSvgObject } from './types';

const ChartLineData02Icon: IconSvgObject = [
  ["circle", { cx: "9.5", cy: "10.5", r: "1.5", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "15.5", cy: "15.5", r: "1.5", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["circle", { cx: "19.5", cy: "7.5", r: "1.5", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M16.4341 14.2963L19 9M10.5825 11.5684L14.2038 14.2963M3.5 20.5L8.58957 11.8792", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M21 21H3V3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default ChartLineData02Icon;
